import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-ink text-bone overflow-hidden">
      <div className="w-full max-w-[90rem] mx-auto px-6 sm:px-8 lg:px-12 pt-24 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <p className="label text-bone/60">An Adelaide studio working across Australia</p>
            <p className="display text-4xl md:text-5xl mt-6 max-w-xl leading-[1.05]">
              Tell us what you are building. We will reply within one business day with a clear plan and an honest estimate.
            </p>
            <a
              href="/#contact"
              data-testid="footer-cta"
              className="inline-flex items-center mt-10 gap-3 text-bone group"
            >
              <span className="display italic text-2xl border-b border-bone/40 pb-1 group-hover:border-clay group-hover:text-clay transition-colors">
                Start your project
              </span>
              <span className="text-2xl">→</span>
            </a>
          </div>

          <div className="md:col-span-2">
            <p className="label text-bone/40 mb-5">Studio</p>
            <p className="text-sm leading-relaxed">
              2/36A Scott Street<br />Pooraka SA 5095<br />Australia
            </p>
          </div>

          <div className="md:col-span-2">
            <p className="label text-bone/40 mb-5">Contact</p>
            <a href="tel:+61435510645" data-testid="footer-phone" className="block text-sm hover:text-clay transition-colors">0435 510 645</a>
            <a href="mailto:drafting@virarc.com.au" data-testid="footer-email" className="block text-sm hover:text-clay transition-colors mt-1.5">drafting@virarc.com.au</a>
          </div>

          <div className="md:col-span-2">
            <p className="label text-bone/40 mb-5">Index</p>
            <a href="/#work" className="block text-sm hover:text-clay transition-colors">Work</a>
            <a href="/#studio" className="block text-sm hover:text-clay transition-colors mt-1.5">Studio</a>
            <Link to="/journal" className="block text-sm hover:text-clay transition-colors mt-1.5">Journal</Link>
            <a href="/#estimator" className="block text-sm hover:text-clay transition-colors mt-1.5">Estimator</a>
          </div>
        </div>

        <div className="mt-24 -mx-6 sm:-mx-8 lg:-mx-12 px-6 sm:px-8 lg:px-12 select-none">
          <p className="display text-[18vw] leading-[0.82] tracking-tighter text-bone/95">VIRARC</p>
        </div>

        <div className="mt-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 border-t border-bone/15 pt-8">
          <p className="label text-bone/40">© {new Date().getFullYear()} Virarc Pty Ltd — All rights reserved</p>
          <p className="label text-bone/40">ABN held · Licensed builder · SA · NSW · VIC · QLD · WA · TAS</p>
        </div>
      </div>
    </footer>
  );
}
